/* global google */
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import * as Sentry from '@sentry/ember';

type Options = {
  key: string;
};

/**
 * The js-api-loader bootstrap defines the `google.maps` namespace stub as soon
 * as it runs, so `google && google.maps` is truthy even when the actual API
 * script is blocked (e.g. in China) or still loading. Checking a real
 * constructor is the only reliable signal that Maps can actually be used.
 */
export function isGoogleMapsAvailable(): boolean {
  return typeof google !== 'undefined' && Boolean(google.maps?.Map);
}

export async function initializeGoogleMaps(options: Options): Promise<void> {
  const { key } = options;

  setOptions({
    key,
    v: 'quarterly',
  });

  try {
    await importLibrary('places');
  } catch (error) {
    // Most google maps issues are because they are blocked in certain regions
    // This just helps us format the error a little
    console.log(error);
    Sentry.captureException('Google maps failed to load');
  }
}
